import { render, staticRenderFns } from "./BmvButton.vue?vue&type=template&id=35d6f4f0&scoped=true"
import script from "./BmvButton.vue?vue&type=script&lang=js"
export * from "./BmvButton.vue?vue&type=script&lang=js"
import style0 from "./BmvButton.vue?vue&type=style&index=0&id=35d6f4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d6f4f0",
  null
  
)

export default component.exports